import SettingsForm from '@/components/settings/SettingsForm';
import AccountSettings from '@/components/settings/AccountSettings';

export default function SettingsPage() {
  return (
    <div className="mx-auto max-w-2xl p-6">
      <h1 className="mb-6 text-2xl font-bold text-neutral-900">Settings</h1>

      <div className="space-y-8">
        <SettingsForm />
        <hr className="border-neutral-200" />
        <AccountSettings />
      </div>
    </div>
  );
}
